/**
 * Adds UTM parameters to a URL if it doesn't already have query parameters
 */
export function addUtmParams(url: string, ctaText: string): string {
    if (url.includes('?')) {
        return url;
    }

    // Automatically populate utm_source, utm_medium, and utm_campaign
    // so that we can track the performance of the CTA
    const utmCampaign = ctaText
        .toLowerCase()
        .split(' ')
        .slice(0, 3)
        .join('_')
        .replace(/[^a-zA-Z0-9_]/g, '_');

    return `${url}?utm_source=lumen5_website&utm_medium=content&utm_campaign=${utmCampaign}`;
}
